import { LoginForm } from "../components/form/LoginForm";
import HeaderLogo from "../components/shared/HeaderLogo";
import { Box } from "@mui/system";

const LoginPage = () => {
    
    const loginPageStyle = {
        display: "flex",
        justifyContent: 'center',
        height: "100vh"
    };

    const loginContainerStyle = {
        justifySelf: "center",
        display: "grid",
        gridAutoRows: "1fr 2fr"
    }

    const headerLogoStyle = {
        maxHeight: "150px",
        minWidth: "350px",
        alignItems: "end"
    };

    return(
        <Box sx={loginPageStyle}>
            <div style={loginContainerStyle}>
                <HeaderLogo {...headerLogoStyle}/>
                <div style={{margin: "1em auto 0"}}>
                    <LoginForm/>
                </div>
            </div>
        </Box>
    ); 
};

export default LoginPage;